(function(){
  if(!('IntersectionObserver' in window)) return;
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if(window.Shopify && window.Shopify.designMode) return;
  var css=document.createElement('style');
  css.textContent='.tm-rv{opacity:0;transform:translateY(18px);transition:opacity 1.1s ease,transform 1.1s ease}.tm-rv.is-in{opacity:1;transform:none}';
  document.head.appendChild(css);
  var els=[].slice.call(document.querySelectorAll('.tm-sec > .tm-wrap, .tm-sec > figure, .tm-award .tm-wrap'));
  var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px',threshold:0.08});
  els.forEach(function(el){var r=el.getBoundingClientRect();if(r.top<window.innerHeight*0.9)return;el.classList.add('tm-rv');io.observe(el);});
})();
